import React from 'react';
import styled from 'styled-components';
import Check from '../../../../assets/Check.png';

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: #FAF5F3;
`;

const Inner = styled.div`
  width: 100%;
  padding: 0 1rem;
  @media (min-width: 640px) {
    padding: 0 1.5rem;
  }
  @media (min-width: 1024px) {
    padding: 0 2rem;
  }
`;

const Title = styled.h2`
  text-align: center;
  font-size: 1.875rem;
  font-weight: 700;
  color: #111827;
  margin-bottom: 2rem;
  margin-top: 2rem;
`;

const Subtitle = styled.p`
  text-align: center;
  color: #6B7280;
  margin-bottom: 2rem;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
  @media (min-width: 640px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (min-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

const Card = styled.div`
  background: #fff;
  border-radius: 0.75rem;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;

const CardTitle = styled.h3`
  font-size: 2.25rem;
  font-weight: 700;
  color: #14532d;
  margin-bottom: 1rem;
  text-align: center;
  height: 80px;
  padding-bottom: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  span {
    font-size: 1.25rem;
    display: block;
    font-weight: 400;
    margin-bottom: 0.25rem;
  }
`;

const FeatureList = styled.ul`
  margin-bottom: 1rem;
  border-top: 1px solid #e5e7eb;
  padding-top: 1rem;
  height: 200px;
  list-style: none;
`;

const FeatureListTitle = styled.h3`
  margin-bottom: 1rem;
  font-size: 1rem;
  font-weight: 600;
`;

const Feature = styled.li`
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
  color: #222;
  font-size: 1rem;
`;

const CheckIcon = styled.img`
  width: 18px;
  height: 18px;
  margin-right: 1rem;
  display: inline-block;
`;

const Button = styled.a`
  width: 100%;
  display: block;
  background: #F87B15;
  color: #111;
  font-weight: 700;
  padding: 0.5rem 0;
  border-radius: 9999px;
  text-align: center;
  text-decoration: none;
  font-size: 1rem;
  margin-top: auto;
  transition: background 0.2s;
  &:hover {
    background: #eab308;
    color: #000;
  }
`;

export default function PricingTable() {
  return (
    <Wrapper>
      <Inner>
        <Title>Find the right plan for you</Title>
        <Subtitle>
          Whether you need basic monitoring or full-featured security,
          we&apos;ve got a plan. Choose what works for you.
        </Subtitle>
        <Grid>
          {/* Free Plan */}
          <Card>
            <CardTitle>Free</CardTitle>
            <FeatureList>
              <FeatureListTitle>Includes:</FeatureListTitle>
              <Feature>
                <CheckIcon src={Check} alt="" />
                Live view & motion alerts
              </Feature>
              <Feature>
                <CheckIcon src={Check} alt="" />
                Local storage support (microSD included)
              </Feature>
              <Feature>
                <CheckIcon src={Check} alt="" />
                Basic motion detection
              </Feature>
            </FeatureList>
            <Button href="#">Your Current Plan</Button>
          </Card>
          {/* Monthly Plan */}
          <Card>
            <CardTitle>
              <span>Monthly plan</span>$29/mo
            </CardTitle>
            <FeatureList>
              <FeatureListTitle>Includes:</FeatureListTitle>
              <Feature>
                <CheckIcon src={Check} alt="" />
                Everything in Basic, plus:
              </Feature>
              <Feature>
                <CheckIcon src={Check} alt="" />
                7-day cloud storage
              </Feature>
              <Feature>
                <CheckIcon src={Check} alt="" />
                AI detection for people and pets
              </Feature>
              <Feature>
                <CheckIcon src={Check} alt="" />
                Activity zones
              </Feature>
            </FeatureList>
            <Button href="#">Link to App</Button>
          </Card>
          {/* Yearly Plan */}
          <Card>
            <CardTitle>
              <span>Yearly plan</span>$49/mo
            </CardTitle>
            <FeatureList>
              <FeatureListTitle>Includes:</FeatureListTitle>
              <Feature>
                <CheckIcon src={Check} alt="" />
                Everything in Business, plus:
              </Feature>
              <Feature>
                <CheckIcon src={Check} alt="" />
                30-day cloud storage
              </Feature>
              <Feature>
                <CheckIcon src={Check} alt="" />
                Continuous recording option
              </Feature>
              <Feature>
                <CheckIcon src={Check} alt="" />
                Facial recognition alerts
              </Feature>
            </FeatureList>
            <Button href="#">Get started</Button>
          </Card>
        </Grid>
      </Inner>
    </Wrapper>
  );
}